import React from 'react';
import classNames from 'classnames';
import './index.scss';

export const Ad = ({ src, category, title, date, size, type, contentHeightSmall = false }) => {
    return (
        <div className='revue-ad'>
            <img className='revue-ad__img' src={src} alt='news' />
            <div
                className={classNames('revue-ad__content', {
                    'revue-ad__content_big': size === 'big',
                    'revue-ad__content_inverted': type === 'inverted',
                    'revue-ad__content_small': contentHeightSmall
                })}
            >
                {category ? <div className='revue-ad__category'>{category}</div> : null}
                {title ? <div className='revue-ad__title'>{title}</div> : null}
                {date ? <div className='revue-ad__date'>{date}</div> : null}
            </div>
        </div>
    );
};
